export default [
    {  
        type:'text',
        name:'regionName',
        label: 'Region Name',
        validation: 'required',
        autocomplete: 'off'
    },
]